module.exports = __webpack_public_path__ + "img/warning.f384956d.svg";